import axios from 'axios'
import $store from '@/store'
import {
  camelCaseKeys,
  // snakeCaseKeys
} from '@/util'
import { setError } from './proxyErrorParser'

const _axios = axios.create({
  baseURL: `${process.env.common.defaultApi.host}/api`,
})

_axios.interceptors.request.use(
  async (config) => {
    await $store.dispatch('auth/sync')
    if (config.isInterceptor !== false) {
      if (
        config.headers.Authorization == null ||
        config.headers.Authorization.startsWith('Basic') === false
      ) {
        const token = $store.state.auth.token
        if (token != null) {
          config.headers.Authorization = `JWT ${token}`
        }
      }
    }
    // snakeCaseKeys 강제변환
    // console.log(config, config.data)
    // if (config.convert !== false) {
    //  config.data = snakeCaseKeys(config.data)
    // }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)

const ignoreCaseTransform = ['/codes']

_axios.interceptors.response.use(
  (resp) => {
    // 응답 객체 가공 무시
    if (ignoreCaseTransform.includes(JSON.parse(resp.config.data).url)) {
      return Promise.resolve(resp)
    }

    return Promise.resolve(camelCaseKeys(resp))
  },
  async (error) => {
    const { response } = error
    if (response?.status === 403) {
      $store.dispatch('auth/signout')
    }

    const errorResponse = setError(response)

    return Promise.reject(camelCaseKeys(errorResponse))
  },
)

function get(url) {
  return proxy('GET', url)
}
function del(url) {
  return proxy('DELETE', url)
}
function put(url, body) {
  return proxy('PUT', url, body)
}
function post(url, body) {
  return proxy('POST', url, body)
}

function proxy(method, url, body = {}) {
  return _axios.post('/fundanow-gateway/proxy/', {
    method,
    url,
    body,
  })
}

export default { get, put, post, del }
